(function () {
  function setupDesktopNav() {
    var nav = document.querySelector('.vicca-d1-nav');
    if (!nav) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('.vicca-d1-item-products, .vicca-d1-item-company'));
    function closeAll() {
      items.forEach(function (item) {
        item.classList.remove('is-open');
        item.classList.remove('is-pinned');
        var button = item.querySelector('.vicca-d1-chevron');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }
    function openItem(item) {
      closeAll();
      item.classList.add('is-open');
      item.querySelector('.vicca-d1-chevron').setAttribute('aria-expanded', 'true');
    }
    items.forEach(function (item) {
      var button = item.querySelector('.vicca-d1-chevron');
      if (!button) return;
      button.addEventListener('click', function () {
        var wasPinned = item.classList.contains('is-pinned');
        if (wasPinned) closeAll();
        else {
          openItem(item);
          item.classList.add('is-pinned');
        }
      });
      item.addEventListener('mouseenter', function () { openItem(item); });
      item.addEventListener('mouseleave', function () {
        if (!item.contains(document.activeElement)) closeAll();
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeAll();
      });
      item.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' && event.target.closest('.vicca-d1-item-label')) {
          event.preventDefault();
          openItem(item);
          var firstLink = item.querySelector('.vicca-d1-panel a');
          if (firstLink) window.requestAnimationFrame(function () { firstLink.focus(); });
        }
      });
    });
    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) closeAll();
    });
    nav.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
        var focused = document.activeElement;
        var parent = focused && focused.closest('.vicca-d1-item');
        if (parent) {
          var button = parent.querySelector('.vicca-d1-chevron');
          if (button) button.focus();
        }
      }
    });
  }

  function setupMobileNav() {
    var nav = document.querySelector('[data-vicca-mobile-nav]');
    if (!nav) return;
    var panels = Array.prototype.slice.call(nav.querySelectorAll('[data-vicca-panel]'));
    function showPanel(name, focusBack) {
      var active = null;
      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-vicca-panel') === name;
        panel.hidden = !isActive;
        if (isActive) active = panel;
      });
      var scroller = nav.closest('.tab-content');
      if (scroller) scroller.scrollTop = 0;
      if (focusBack && active) {
        var focusTarget = active.querySelector('[data-vicca-back]') || active.querySelector('button, a');
        if (focusTarget) focusTarget.focus();
      }
    }
    nav.addEventListener('click', function (event) {
      var target = event.target.closest('[data-vicca-target]');
      var back = event.target.closest('[data-vicca-back]');
      if (target) showPanel(target.getAttribute('data-vicca-target'), true);
      if (back) showPanel(back.getAttribute('data-vicca-back'), true);
    });
    var opener = document.querySelector('.menu_moblie .menuleft');
    if (opener) opener.addEventListener('click', function () { showPanel('root', false); });
    nav.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var active = nav.querySelector('[data-vicca-panel]:not([hidden])');
      var back = active && active.querySelector('[data-vicca-back]');
      if (back) {
        event.preventDefault();
        showPanel(back.getAttribute('data-vicca-back'), true);
      } else if (active) {
        event.preventDefault();
        var closer = document.querySelector('.close-menu-mobile');
        if (closer) closer.click();
        if (opener) opener.focus();
      }
    });
  }

  function setupDialogs() {
    var root = document.documentElement;
    var specs = [
      { selector: '.js-poup-login-destop', close: '.js-eveland-close-login' },
      { selector: '.js-minicart', close: '.close-mini-cart' },
      { selector: '.js-box-search', close: '.js-drawer-close' }
    ];
    var dialogs = specs.map(function (spec) {
      return { node: document.querySelector(spec.selector), close: spec.close };
    }).filter(function (spec) { return spec.node; });
    var current = null;
    var opener = null;
    var background = [];
    function focusables(node) {
      return Array.prototype.slice.call(node.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]')).filter(function (el) {
        return !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
      });
    }
    function sync() {
      dialogs.forEach(function (spec) {
        var opened = spec.node.classList.contains('active');
        spec.node.inert = !opened;
        spec.node.setAttribute('aria-hidden', opened ? 'false' : 'true');
      });
      var active = dialogs.find(function (spec) { return spec.node.classList.contains('active'); });
      if (active === current) return;
      if (active) {
        opener = document.activeElement;
        root.classList.add('vicca-d1-modal-open');
        background = Array.prototype.slice.call(document.querySelectorAll('#header, .menu_moblie, .vicca-d1-top-header, #shopify-section-footer'));
        background.forEach(function (el) { if (!el.inert) { el.inert = true; el.setAttribute('data-vicca-dialog-inert', ''); } });
        active.node.setAttribute('role', 'dialog');
        active.node.setAttribute('aria-modal', 'true');
        active.node.setAttribute('tabindex', '-1');
        if (!active.node.hasAttribute('aria-label')) active.node.setAttribute('aria-label', 'Buscar');
        current = active;
        window.setTimeout(function () {
          if (current !== active) return;
          var target = active.node.querySelector(active.close) || focusables(active.node)[0] || active.node;
          target.focus({ preventScroll: true });
        }, 160);
      } else {
        root.classList.remove('vicca-d1-modal-open');
        background.forEach(function (el) { if (el.hasAttribute('data-vicca-dialog-inert')) { el.inert = false; el.removeAttribute('data-vicca-dialog-inert'); } });
        current = null;
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      }
    }
    dialogs.forEach(function (spec) { new MutationObserver(sync).observe(spec.node, { attributes: true, attributeFilter: ['class'] }); });
    document.addEventListener('keydown', function (event) {
      if (!current) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        var closer = current.node.querySelector(current.close);
        if (closer) closer.click();
      } else if (event.key === 'Tab') {
        var list = focusables(current.node);
        var first = list[0];
        var last = list[list.length - 1];
        if (!first) { event.preventDefault(); current.node.focus(); }
        else if (event.shiftKey && (document.activeElement === first || !current.node.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !current.node.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      }
    });
    var previewWrapper = null;
    var previewObserver = new ResizeObserver(function () { measurePreview(); });
    function measurePreview() {
      var height = previewWrapper ? previewWrapper.getBoundingClientRect().height : 0;
      root.style.setProperty('--vicca-d1-overlay-bottom', Math.ceil(height) + 'px');
    }
    function previewSpace() {
      root.classList.toggle('vicca-d1-preview', !!document.getElementById('PBarNextFrame'));
      var wrapper = document.getElementById('PBarNextFrameWrapper');
      if (wrapper !== previewWrapper) {
        previewObserver.disconnect();
        previewWrapper = wrapper;
        if (wrapper) previewObserver.observe(wrapper);
        measurePreview();
      }
    }
    new MutationObserver(previewSpace).observe(document.body, { childList: true, subtree: true });
    previewSpace();
    var badges = document.querySelectorAll('.vicca-d1-cart-count');
    badges.forEach(function (badge) {
      function countChanged() {
        var count = parseInt(badge.textContent, 10) || 0;
        badge.hidden = count === 0;
        badge.parentElement.setAttribute('aria-label', 'Carrito, ' + count + ' productos');
      }
      new MutationObserver(countChanged).observe(badge, { childList: true, characterData: true, subtree: true });
      countChanged();
    });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupDesktopNav();
      setupMobileNav();
      setupDialogs();
    });
  } else {
    setupDesktopNav();
    setupMobileNav();
    setupDialogs();
  }
}());
